module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "submenu clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.subpage == 'alapadatok'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function () {
        _vm.subpage = 'alapadatok'
      }
    }
  }, [_vm._v("Alapadatok")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.subpage == 'publikaciok'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function () {
        _vm.subpage = 'publikaciok'
      }
    }
  }, [_vm._v("Publikációk")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.subpage == 'adathozzajarulas'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function () {
        _vm.subpage = 'adathozzajarulas'
      }
    }
  }, [_vm._v("Adathozzájárulás")])])])])]), _vm._v(" "), (_vm.subpage == 'alapadatok') ? _c('Alapadatok', {
    attrs: {
      "showProgressInfo": _vm.showProgressInfo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'adathozzajarulas') ? _c('AdatHozzajarulas', {
    attrs: {
      "showProgressInfo": _vm.showProgressInfo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'publikaciok') ? _c('Publikaciok', {
    attrs: {
      "changeSubPage": _vm.changeSubPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'publikacio') ? _c('Publikacio', {
    attrs: {
      "showProgressInfo": _vm.showProgressInfo,
      "changeSubPage": _vm.changeSubPage
    }
  }) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.progressInfo,
      "hideProgressInfo": _vm.hideProgressInfo
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        Alapadatok\n        "), _c('span', [_vm._v("Felhasználó alapadatai")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ccc5ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/profilepage.vue
// module id = 340
// module chunks = 0